const PHONE = '919876543210';
const DEFAULT_MSG = "Hello Forma Interiors, I'd like to discuss a project with you.";

export function waLink(message = DEFAULT_MSG) {
  return `https://wa.me/${PHONE}?text=${encodeURIComponent(message)}`;
}

export function openWhatsApp(message) {
  window.open(waLink(message), '_blank', 'noopener,noreferrer');
}
